

  async function init() {
    const app = document.getElementById("bundleApp");

    if (!app) return;

    if (!app.querySelector(".bundle-top-bar")) {
      app.insertAdjacentHTML(
        "beforeend",
        `
      <div class="bundle-top-bar">
        <div class="bundle-bar-inner">

          <div>
            <span id="bundleStatus">0 sheet</span>
            <span id="bundleNext"></span>
          </div>

          <div class="bundle-progress">
            <div id="bundleProgress"></div>
          </div>

          <div class="bundle-right">
            <span id="bundleSaving">Saving $0</span>

            <button id="bundleCheckout">
              <span class="btn-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M7 4h-2l-1 2h2l3.6 7.59-1.35 2.44C7.89 16.37 8.48 17 9.24 17H19v-2H9.42c-.14 0-.25-.11-.25-.25l.03-.12L10.1 13h6.45c.75 0 1.41-.41 1.75-1.03L21 6H6.21l-.94-2z"/>
                </span>
              </span>

              <span id="bundleBtnText">
                Add to Cart - $0.00
              </span>
            </button>

            <button id="bundleReset" style="margin-right:10px;">
              Reset
            </button>

          </div>

        </div>
      </div>

      <div id="bundleCollections"></div>
    `,
      );
    }

    const container = document.getElementById("bundleCollections");
    const productCache = {};

    await Promise.all(
      allProducts.map(async (handle) => {
        try {
          const res = await fetch(
            `https://truflatplywood.com/products/${handle}.js?currency=USD`,
          );

          productCache[handle] = await res.json();
        } catch (err) {
          console.error("Failed:", handle, err);
        }
      }),
    );

    const shopAll = collections.find((c) => c.isShopAll);

    if (shopAll) {
      shopAll.products = [
        // First
        {
          handle: "truflat-starter-pack",
          qtyOptions: Array.from({ length: 10 }, (_, i) => i + 1),
          isPack: true,
        },

        // Single sheets
        {
          handle: "truflat-maple-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },
        {
          handle: "truflat-oak-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },
        {
          handle: "truflat-cherry-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },
        {
          handle: "truflat-walnut-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },
        {
          handle: "truflat-linen-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },
        {
          handle: "truflat-black-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },
        {
          handle: "truflat®-white-2-0-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },
        {
          handle: "truflat®-paint-plywood",
          qtyOptions: [5, 10, 15, 20, 25, 30],
          isPack: false,
        },

        // Last two packs
        {
          handle: "truflat-color-series-pack",
          qtyOptions: Array.from({ length: 10 }, (_, i) => i + 1),
          isPack: true,
        },
        {
          handle: "truflat-wood-series-pack",
          qtyOptions: Array.from({ length: 10 }, (_, i) => i + 1),
          isPack: true,
        },
      ];
    }

    /* =========================
     CREATE TAB MENU
  ========================= */

    const tabsWrapper = document.createElement("div");
    tabsWrapper.className = "bundle-tabs";

    container.before(tabsWrapper);

    /* =========================
     CREATE COLLECTIONS
  ========================= */

    for (const [index, collection] of collections.entries()) {
      /* ===== TAB ===== */

      const tab = document.createElement("button");

      tab.className = `bundle-tab ${index === 0 ? "active" : ""}`;

      tab.setAttribute("data-tab", index);

      tab.innerHTML = `
      <span class="collection-icon">
        ${collection.icon}
      </span>

      <span>
        ${collection.title}
      </span>
    `;

      tabsWrapper.appendChild(tab);

      /* ===== CONTENT ===== */

      const section = document.createElement("div");

      section.className = `bundle-tab-content ${index === 0 ? "active" : ""}`;

      section.setAttribute("data-content", index);

      if (index !== 0) {
        section.style.display = "none";
      }

      section.innerHTML = `
  
  <div class="bundle-grid"></div>
`;

      const grid = section.querySelector(".bundle-grid");

      /* ===== PRODUCTS ===== */

      for (let i = 0; i < collection.products.length; i++) {
        const item = collection.products[i];

        const handle = typeof item === "string" ? item : item.handle;

        const qtyOptions =
          typeof item === "string" ? collection.qtyOptions : item.qtyOptions;

        const isPack =
          typeof item === "string"
            ? collection.title === "TruFlat® Packs"
            : item.isPack;

        const product = productCache[handle];

        const card = createCard(product, i, qtyOptions, isPack);

        grid.appendChild(card);
      }

      container.appendChild(section);
    }

    /* =========================
     TAB SWITCH
  ========================= */

    document.querySelectorAll(".bundle-tab").forEach((tab) => {
      tab.addEventListener("click", function () {
        const currentTab = this.getAttribute("data-tab");

        /* REMOVE ACTIVE */

        document.querySelectorAll(".bundle-tab").forEach((btn) => {
          btn.classList.remove("active");
        });

        document.querySelectorAll(".bundle-tab-content").forEach((content) => {
          content.classList.remove("active");
          content.style.display = "none";
        });

        /* ADD ACTIVE */

        this.classList.add("active");

        const activeContent = document.querySelector(
          `.bundle-tab-content[data-content="${currentTab}"]`,
        );

        if (activeContent) {
          activeContent.classList.add("active");
          activeContent.style.display = "block";
        }
      });
    });

    attachCheckout();
    const loader = document.getElementById("bundleLoader");
    if (loader) {
      loader.style.display = "none";
    }
  }

  function createCard(product, index, qtyValues = [1], isPack = false) {
    const card = document.createElement("div");
    card.className = "bundle-card";

    const variantMap = {};
    product.variants.forEach((v) => {
      if (v.available) variantMap[v.id] = v;
    });

    const sizeOptions = Object.values(variantMap)
      .map(
        (v) => `
    <option value="${v.id}">${v.option2}</option>
  `,
      )
      .join("");

    const qtyOptions = qtyValues
      .map(
        (val, index) =>
          `<option value="${val}" ${index === 0 ? "selected" : ""}>${val}</option>`,
      )
      .join("");

    const image = product.featured_image.startsWith("//")
      ? "https:" + product.featured_image
      : product.featured_image;

    card.innerHTML = `
    ${index < 2 ? `<span class="bundle-tag">Popular</span>` : ""}
    <div class="product_image">
        <img src="${image}" />
    </div>
    <div class="product_details">
        <div class="wrap_title">
            <h4>${product.title}</h4>
            <div class="rating">
                <div style="display:flex;gap:2px;margin-bottom:6px;">
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="#000"><polygon points="10,1 12.6,7.2 19,7.3 13.8,11.3 15.9,17.6 10,13.8 4.1,17.6 6.2,11.3 1,7.3 7.4,7.2"></polygon></svg><svg width="16" height="16" viewBox="0 0 20 20" fill="#000"><polygon points="10,1 12.6,7.2 19,7.3 13.8,11.3 15.9,17.6 10,13.8 4.1,17.6 6.2,11.3 1,7.3 7.4,7.2"></polygon></svg><svg width="16" height="16" viewBox="0 0 20 20" fill="#000"><polygon points="10,1 12.6,7.2 19,7.3 13.8,11.3 15.9,17.6 10,13.8 4.1,17.6 6.2,11.3 1,7.3 7.4,7.2"></polygon></svg><svg width="16" height="16" viewBox="0 0 20 20" fill="#000"><polygon points="10,1 12.6,7.2 19,7.3 13.8,11.3 15.9,17.6 10,13.8 4.1,17.6 6.2,11.3 1,7.3 7.4,7.2"></polygon></svg><svg width="16" height="16" viewBox="0 0 20 20" fill="#000"><polygon points="10,1 12.6,7.2 19,7.3 13.8,11.3 15.9,17.6 10,13.8 4.1,17.6 6.2,11.3 1,7.3 7.4,7.2"></polygon></svg>
                </div>
                (50+)
            </div>
        </div>
        <div class="options">
            <label>Size:</label>
            <select name="variant" class="variant">${sizeOptions}</select>
        </div>
        ${
          isPack
            ? `<div class="bundle-pack-note">
         Includes 7 sheets of 1/8" x 12" x 19"
       </div>`
            : ""
        }

        <div class="options">
            <label>Quantity:</label>
            <select name="qty" class="qty">${qtyOptions}</select>
        </div>
        <div class="price">$<span class="priceVal"></span> USD</div>
        <button class="add-btn">+ Add to Bundle</button>
    </div>
  `;

    const variantSelect = card.querySelector(".variant");
    const qtySelect = card.querySelector(".qty");
    const priceEl = card.querySelector(".priceVal");

    function getVariant() {
      return variantMap[variantSelect.value];
    }

    function updatePrice() {
      const variant = getVariant();
      if (!variant) return;

      const qty = parseInt(qtySelect.value, 10);
      const total = (variant.price * qty) / 100;

      priceEl.innerText = total.toFixed(2);
    }

    variantSelect.selectedIndex = 0;
    updatePrice();

    variantSelect.addEventListener("change", updatePrice);
    qtySelect.addEventListener("change", updatePrice);

    card.querySelector(".add-btn").addEventListener("click", () => {
      const variant = getVariant();
      const qty = parseInt(qtySelect.value, 10);

      if (!variant) return;

      if (bundleItems[variant.id]) {
        bundleItems[variant.id].qty += qty;
      } else {
        bundleItems[variant.id] = {
          qty,
          price: variant.price / 100,
        };
      }

      updateBundle();

      const btn = card.querySelector(".add-btn");
      btn.innerText = "Added ✓";
      setTimeout(() => (btn.innerText = "+ Add to Bundle"), 1000);
    });

    return card;
  }
  function updateBundle() {
    let totalSheets = 0;
    let totalPrice = 0;

    Object.values(bundleItems).forEach((item) => {
      totalSheets += item.qty;
      totalPrice += item.qty * item.price;
    });

    const progress = document.getElementById("bundleProgress");
    if (!progress) return;
    const status = document.getElementById("bundleStatus");
    const next = document.getElementById("bundleNext");
    const savingEl = document.getElementById("bundleSaving");
    const btnText = document.getElementById("bundleBtnText");

    let percent = Math.min(totalSheets, 100);
    progress.style.width = percent + "%";

    let discount = 0;
    let nextTarget = 50;

    if (totalSheets >= 100) {
      discount = 20;
      nextTarget = null;
    } else if (totalSheets >= 50) {
      discount = 10;
      nextTarget = 100;
    } else {
      discount = 0;
      nextTarget = 50;
    }

    const discountAmount = (totalPrice * discount) / 100;
    const finalPrice = totalPrice - discountAmount;

    status.innerText = `${totalSheets} sheets ${discount ? `(${discount}% OFF)` : ""}`;

    if (nextTarget) {
      const remain = nextTarget - totalSheets;
      const nextDiscount = nextTarget === 50 ? 10 : 20;
      next.innerText = `Add ${remain} more to unlock ${nextDiscount}% OFF`;
    } else {
      next.innerText = "Max discount unlocked 🎉";
    }

    if (discount > 0) {
      savingEl.innerText = `${discount}% OFF • Saving $${discountAmount.toFixed(2)}`;
    } else {
      savingEl.innerText = "No discount yet";
    }

    btnText.innerText = `Add to Cart - $${finalPrice.toFixed(2)}`;

    const bar = document.querySelector(".bundle-top-bar");

    if (bar) {
      if (totalSheets > 0) {
        bar.classList.add("active");
      } else {
        bar.classList.remove("active");
      }
    }
  }

  function attachCheckout() {
    const btn = document.getElementById("bundleCheckout");

    if (!btn) {
      setTimeout(attachCheckout, 200);
      return;
    }

    btn.addEventListener("click", () => {
      if (Object.keys(bundleItems).length === 0) {
        alert("No items selected");
        return;
      }

      const cartItems = Object.keys(bundleItems)
        .map((id) => `${id}:${bundleItems[id].qty}`)
        .join(",");

      let checkoutUrl = `https://truflatplywood.com/cart/${cartItems}`;

      window.open(checkoutUrl, "_blank");
    });
    const resetBtn = document.getElementById("bundleReset");

    if (resetBtn && !resetBtn.dataset.bound) {
      resetBtn.dataset.bound = "true";

      resetBtn.addEventListener("click", () => {
        resetBundle();
      });
    }
  }

  function resetBundle() {
    // clear all items
    bundleItems = {};
    updateBundle();
    const bar = document.querySelector(".bundle-top-bar");
    if (bar) bar.classList.remove("active");

    // reset UI safely
    const progress = document.getElementById("bundleProgress");
    const status = document.getElementById("bundleStatus");
    const next = document.getElementById("bundleNext");
    const savingEl = document.getElementById("bundleSaving");
    const btnText = document.getElementById("bundleBtnText");

    if (progress) progress.style.width = "0%";

    if (status) status.innerText = "0 sheet";
    if (next) next.innerText = "";
    if (savingEl) savingEl.innerText = "Saving $0";
    if (btnText) btnText.innerText = "Add to Cart - $0.00";

    // OPTIONAL: reset all qty dropdowns to 1
    document.querySelectorAll("#bundleSafeMount .qty").forEach((el) => {
      el.selectedIndex = 0;
    });
  }

  // === ULTRA SAFE DELAYED START FOR PAGEDECK ===

  window.addEventListener("load", function () {
    setTimeout(function () {
      var anchor = document.getElementById("bundleApp");
      if (!anchor) return;

      var mount = document.getElementById("bundleSafeMount");
      if (!mount) {
        mount = document.createElement("div");
        mount.id = "bundleSafeMount";
        anchor.appendChild(mount); // mount exactly here
      }

      init(); // your existing function
    }, 1000); // 1 second AFTER full load
  });

  const tabsWrapper = document.createElement("div");
  tabsWrapper.className = "bundle-tabs";

  container.before(tabsWrapper);

  /* =========================
     CREATE COLLECTIONS
  ========================= */
  for (const [index, collection] of collections.entries()) {
    /* ===== TAB ===== */
    const tab = document.createElement("button");
    tab.className = `bundle-tab ${index === 0 ? "active" : ""}`;
    tab.setAttribute("data-tab", index);

    tab.innerHTML = `
      <span class="collection-icon">${collection.icon}</span>
      <span>${collection.title}</span>
    `;

    tabsWrapper.appendChild(tab);

    /* ===== CONTENT ===== */
    const section = document.createElement("div");
    section.className = `bundle-tab-content ${index === 0 ? "active" : ""}`;
    section.setAttribute("data-content", index);

    if (index !== 0) {
      section.style.display = "none";
    }

    section.innerHTML = `
      <div class="bundle-grid"></div>
    `;

    const grid = section.querySelector(".bundle-grid");

    for (let i = 0; i < collection.products.length; i++) {
      const handle = collection.products[i];

      const product = productCache[handle];

      if (!product) continue;

      const card = createCard(product, i);

      grid.appendChild(card);
    }

    container.appendChild(section);
  }

  /* =========================
     TAB SWITCH SCRIPT
  ========================= */
  document.querySelectorAll(".bundle-tab").forEach((tab) => {
    tab.addEventListener("click", function () {
      const currentTab = this.getAttribute("data-tab");

      // remove active
      document.querySelectorAll(".bundle-tab").forEach((btn) => {
        btn.classList.remove("active");
      });

      document.querySelectorAll(".bundle-tab-content").forEach((content) => {
        content.classList.remove("active");
        content.style.display = "none";
      });

      // add active
      this.classList.add("active");

      const activeContent = document.querySelector(
        `.bundle-tab-content[data-content="${currentTab}"]`,
      );

      if (activeContent) {
        activeContent.classList.add("active");
        activeContent.style.display = "block";
      }
    });
  });
